import { RequestStatus } from '../../enums/request-status';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WebViewState } from './webviewState.model';
import { exocad } from '@exocad/webview-embedded';
import { getWebviewFileAsync } from './actionWebView';

const initialState: WebViewState = {
    webView: new exocad.WebviewAPI.WebviewControls(),
    webViewFile: null,
    requestStatus: RequestStatus.None,
    error: '',
};

const webviewSlice = createSlice({
    name: 'webView',
    initialState,
    reducers: {},
    extraReducers: builder => {
        // @ts-ignore
        builder
            .addCase(getWebviewFileAsync.pending, state => {
                state.requestStatus = RequestStatus.Loading;
            })
            .addCase(getWebviewFileAsync.fulfilled, (state, action: PayloadAction<ArrayBuffer>) => {
                state.requestStatus = RequestStatus.Completed;
                state.webViewFile = action.payload;
            })
            .addCase(getWebviewFileAsync.rejected, (state, action: PayloadAction<string>) => {
                state.requestStatus = RequestStatus.Failed;
                state.error = action.payload;
            });
    },
});

export default webviewSlice.reducer;
